import {
  UserComboboxOptionType,
  UserComboboxUserOption,
} from "@components/user-combobox/user-combobox-list";
import { graphqlNone } from "@helpers/constants";

export const everybodyOption: UserComboboxUserOption = {
  name: "Everybody",
  id: graphqlNone,
  type: UserComboboxOptionType.USER,
};
